<button
  id="selfRecipient"
  mat-icon-button
  [matTooltip]="isSelfRecipient ? iconData.toolTip : 'Disable Self-Receipt'"
  (click)="disableSelfRecipient()"
>
  <mat-icon [ngClass]="{ icon: !isSelfRecipient }">
    {{ iconData.icon }}
  </mat-icon>
</button>
<button
  id="duplicate-alert"
  mat-icon-button
  matTooltip="Duplicate Alert"
  (click)="duplicateAlert()"
>
  <mat-icon class="icon"> file_copy </mat-icon>
</button>
@if (!isSystemGenerated) {
<button
  id="delete-alert"
  mat-icon-button
  matTooltip="Delete Alert"
  (click)="deleteAlert()"
>
  <mat-icon class="icon"> delete_outline </mat-icon>
</button>
}
